/* istanbul ignore file */
import Header from './Header';
import { StyledInsights, StyledInsightsList } from './Insights.style';
import { StyledRowHeader } from '../ProjectProgression.style';
import InsightItem from './InsightItem/InsightItem';
import useInsightsValues from './useInsights/useInsightsValues';
import Loader from './Loader';
import EmptyState from './EmptyState/EmptyState';
import useInsightsList from './useInsights/useInsightsList';
import { useAutoAnimate } from '@formkit/auto-animate/react';
import useEmptyStates from './useInsights/useEmptyStates';

const Insights = () => {
  const [animationParent] = useAutoAnimate({ duration: 1000 });
  const insightsValues = useInsightsValues();
  const insightList = useInsightsList(insightsValues);
  const { isEmptyState, emptyStateType } = useEmptyStates({
    insightList,
    insightsValues
  });

  return (
    <StyledInsights>
      <StyledRowHeader>
        <Header />
      </StyledRowHeader>
      <StyledInsightsList>
        {insightsValues.isLoading ? (
          <Loader />
        ) : (
          <main ref={animationParent}>
            {isEmptyState ? (
              <EmptyState type={emptyStateType} />
            ) : (
              insightList.items.map(insight => {
                const shouldShowInsight =
                  !!insight?.active && insight?.value > 0;

                return (
                  shouldShowInsight && (
                    <InsightItem
                      key={insight.key}
                      insight={insight}
                      toggleCheck={() => insightList.toggleCheck(insight.key)}
                    />
                  )
                );
              })
            )}
          </main>
        )}
      </StyledInsightsList>
    </StyledInsights>
  );
};

export default Insights;
